import type {
	ExtractInjectionAPI,
	PMPlugin,
	PMPluginFactoryParams,
} from '@atlaskit/editor-common/types';

import type { AIPlugin } from '../../aiPluginType';
import type { AIGlobalOptIn } from '../../types/types';

import { createAiQuickPromptKeymapPlugin } from './ai-quick-prompt-plugin-keymap';
import { createAiQuickPromptPlugin } from './ai-quick-prompt-plugin-main';
import { getStandDownManagerOptions, StandDownManager } from './stand-down-manager';

export function createAiQuickPromptPlugins({
	aiGlobalOptIn,
	api,
}: {
	aiGlobalOptIn: AIGlobalOptIn;
	api: ExtractInjectionAPI<AIPlugin> | undefined;
}): PMPlugin[] {
	const standDownManager = new StandDownManager(getStandDownManagerOptions({ api }));

	return [
		{
			name: 'ai-quick-prompt',
			plugin: ({ dispatch, getIntl }: PMPluginFactoryParams) =>
				createAiQuickPromptPlugin({
					dispatch,
					api,
					getIntl,
					standDownManager,
				}),
		},
		{
			name: 'ai-quick-prompt-keymap',
			plugin: () =>
				createAiQuickPromptKeymapPlugin({
					aiGlobalOptIn,
					standDownManager,
				}),
		},
	];
}
